var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgErrorIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 81,
    height: 80,
    viewBox: "0 0 81 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.12,
    cx: 40.7656,
    cy: 40,
    r: 40,
    fill: "#FF5F52"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.0005 34.0001V41.5001M22.394 48.2514C20.6633 51.2514 22.8284 55.0001 26.2919 55.0001H55.7092C59.1726 55.0001 61.3378 51.2514 59.607 48.2514L44.8984 22.7564C43.1666 19.7547 38.8344 19.7547 37.1027 22.7564L22.394 48.2514ZM41.0005 47.5001H41.0155V47.5151H41.0005V47.5001Z",
    stroke: "#FF5F52",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorIcon);
export default __webpack_public_path__ + "static/media/error_icon.835305e5cad602cdb065a926366af46a.svg";
export { ForwardRef as ReactComponent };